<script setup>
const route = useRoute()
if (route.path !== `/ranking/`) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid areaId'
  })
}
useCustomMeta('ranking', '全国')
const breadCrumbList = [{ text: 'ゴルフ場の天気', link: '../' }, { text: 'ランキング' }]
</script>

<template>
  <div>
    <NuxtLayout
      name="ranking"
      :bread-crumb-list="breadCrumbList"
    >
      <GolfRecommendAll />
    </NuxtLayout>
  </div>
</template>
